import React from 'react';
import {alpha, Box, Card, CircularProgress, Stack, Typography} from '@mui/material';

import {Colors} from '@constants/colors.constants';
import {DownRed, UpGreen} from '@icons/index';

interface SmallStatisticsCardProps {
  description?: string;
  progress?: number;
  title?: string;
  unit?: string;
  value: number | string;
  loading?: boolean;
}

const SmallStatisticsCard = (props: SmallStatisticsCardProps) => {
  const {description, progress, title, unit, value, loading} = props;

  let progressColor = Colors.warning;
  if (progress && progress > 0) progressColor = Colors.success;
  if (progress && progress < 0) progressColor = Colors.error;

  return (
    <Card variant="small-statistic">
      <Stack>
        {!!progress && (
          <Box
            position="absolute"
            top="8px"
            right="10px"
            bgcolor={alpha(progressColor, 0.2)}
            px="8px"
            py="2px"
            borderRadius="4px"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {progress > 0 ? <UpGreen/> : <DownRed/>}
              <Typography fontSize={14} fontWeight="700" color={progressColor}>
                {progress}%
              </Typography>
            </Stack>
          </Box>
        )}
        {title && (
          <Typography fontSize={14} fontWeight="400" mb="18px">
            {title}
          </Typography>
        )}
        {loading && <CircularProgress size={30} style={{alignSelf: 'center'}}/>}
        {!loading && (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography fontSize={36} fontWeight="700">
              {value}
            </Typography>
            {unit && (
              <Typography fontSize={14} fontWeight="400" color={Colors.textWithOpacity} pt="4px">
                {unit}
              </Typography>
            )}
          </Stack>
        )}
        {description && (
          <Typography fontSize={14} fontWeight="400" color={Colors.textWithOpacity}>
            {description}
          </Typography>
        )}
      </Stack>
    </Card>
  );
};

export default SmallStatisticsCard;
